import { render } from "./confirmation.vue?vue&type=template&id=6f4ef78d&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"

import "./confirmation.vue?vue&type=style&index=0&id=6f4ef78d&lang=stylus&scoped=true"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4ef78d"]])

export default __exports__